import { z } from "zod";

const manualAddressSchema = z.object({
  street: z.string().min(1),
  number: z.string().min(1),
  complement: z.string().optional(),
  neighborhood: z.string().min(1),
  city: z.string().min(1),
  state: z.string().min(1),
  country: z.string().optional(),
  postal_code: z.string().min(1),
});

const manualSchema = z.object({
  first_name: z.string().min(1),
  last_name: z.string().min(1),
  document: z.string().min(1),
  document_type: z.enum(["cpf", "cnpj"]),
  phone: z.string().min(1),
  birth_date: z.string().optional(),
  address: manualAddressSchema,
});

/** Quando `use_representative_data` é true, não validar `manual` (evita falha se restou objeto parcial no form). */
const partnerPortalMasterFormSchemaInner = z
  .object({
    email: z.string().email(),
    password: z.string().min(8),
    confirmPassword: z.string().min(8),
    use_representative_data: z.boolean(),
    manual: manualSchema.optional(),
  })
  .superRefine((data, ctx) => {
    if (data.password !== data.confirmPassword) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "validationMessages.equalPasswordMessage",
        path: ["confirmPassword"],
      });
    }
    if (!data.use_representative_data && !data.manual) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "clients.partnerPortal.manualRequired",
        path: ["manual"],
      });
    }
  });

export const partnerPortalMasterFormSchema = z.preprocess((raw) => {
  if (raw && typeof raw === "object" && "use_representative_data" in raw) {
    const o = raw as Record<string, unknown>;
    if (o.use_representative_data === true) {
      return { ...o, manual: undefined };
    }
  }
  return raw;
}, partnerPortalMasterFormSchemaInner);

export type TPartnerPortalMasterFormData = z.infer<
  typeof partnerPortalMasterFormSchema
>;
